import axios from "axios";
import { API_BASE, buildAuthHeaders } from "./base";

const API = API_BASE;

function withAuth(token, extra = {}) {
  return {
    headers: {
      ...buildAuthHeaders(token),
      "Content-Type": "application/json",
      ...extra,
    },
  };
}

export async function createMarketplaceCheckout(payload, token = null) {
  const res = await axios.post(`${API}/myboothshare/bookings/checkout`, payload, withAuth(token));
  return res.data;
}

export async function getMarketplaceCheckoutContext(workspaceId, { token = null, occupancyMode = null } = {}) {
  const res = await axios.get(`${API}/myboothshare/workspaces/${workspaceId}/checkout-context`, {
    ...withAuth(token),
    params: occupancyMode ? { occupancy_mode: occupancyMode } : {},
  });
  return res.data;
}

export async function getMarketplacePaymentStatus(bookingId, { token = null, sessionId = null } = {}) {
  const res = await axios.get(`${API}/myboothshare/bookings/${bookingId}/payment-status`, {
    ...withAuth(token),
    params: sessionId ? { session_id: sessionId } : {},
  });
  return res.data;
}

export async function listMyMarketplaceBookings(token) {
  const res = await axios.get(`${API}/myboothshare/account/bookings`, withAuth(token));
  return res.data;
}

export async function createMarketplaceDispute(bookingId, payload, token) {
  const res = await axios.post(
    `${API}/myboothshare/bookings/${bookingId}/disputes`,
    payload,
    withAuth(token)
  );
  return res.data;
}

export async function getMarketplaceConnectStatus(token) {
  const res = await axios.get(`${API}/myboothshare/connect/status`, withAuth(token));
  return res.data;
}

export async function createMarketplaceConnectOnboarding(token, payload = {}) {
  const res = await axios.post(`${API}/myboothshare/connect/onboard`, payload, withAuth(token));
  return res.data;
}

export async function getMarketplaceLedger(token) {
  const res = await axios.get(`${API}/myboothshare/ledger`, withAuth(token));
  return res.data;
}

export async function getMarketplaceAdminBookings(token, params = {}) {
  const res = await axios.get(`${API}/myboothshare/admin/bookings`, {
    ...withAuth(token),
    params,
  });
  return res.data;
}

export async function resolveMarketplaceDispute(token, disputeId, payload) {
  const res = await axios.post(
    `${API}/myboothshare/disputes/${disputeId}/resolve`,
    payload,
    withAuth(token)
  );
  return res.data;
}

export async function releaseMarketplacePayout(token, bookingId, force = false) {
  const res = await axios.post(
    `${API}/myboothshare/admin/bookings/${bookingId}/release-payout`,
    {},
    {
      ...withAuth(token),
      params: force ? { force: true } : {},
    }
  );
  return res.data;
}

export async function processMarketplaceRelease(token, bookingId) {
  const res = await axios.post(
    `${API}/myboothshare/admin/bookings/${bookingId}/process-release`,
    {},
    withAuth(token)
  );
  return res.data;
}

export async function createMarketplaceRefund(token, bookingId, payload) {
  const res = await axios.post(
    `${API}/myboothshare/bookings/${bookingId}/refunds`,
    payload,
    withAuth(token)
  );
  return res.data;
}

export async function getMarketplaceBookingLedgerTimeline(token, bookingId) {
  const res = await axios.get(
    `${API}/myboothshare/bookings/${bookingId}/ledger-timeline`,
    withAuth(token)
  );
  return res.data;
}

export async function getMarketplaceBookingReceipts(token, bookingId) {
  const res = await axios.get(
    `${API}/myboothshare/bookings/${bookingId}/receipts`,
    withAuth(token)
  );
  return res.data;
}

export async function getMarketplaceLeaseLedgerTimeline(token, leaseId) {
  const res = await axios.get(
    `${API}/myboothshare/leases/${leaseId}/ledger-timeline`,
    withAuth(token)
  );
  return res.data;
}

export async function getMarketplaceLeaseReceipts(token, leaseId) {
  const res = await axios.get(
    `${API}/myboothshare/leases/${leaseId}/receipts`,
    withAuth(token)
  );
  return res.data;
}

export async function createWorkspaceFinancePaymentIntent(token, bookingId, payload) {
  const res = await axios.post(
    `${API}/myboothshare/bookings/${bookingId}/payment-intents`,
    payload,
    withAuth(token)
  );
  return res.data;
}

export async function confirmWorkspaceFinancePayment(token, bookingId, payload) {
  const res = await axios.post(
    `${API}/myboothshare/bookings/${bookingId}/confirm-payment`,
    payload,
    withAuth(token)
  );
  return res.data;
}

export async function holdWorkspaceFinanceDeposit(token, bookingId, payload) {
  const res = await axios.post(
    `${API}/myboothshare/bookings/${bookingId}/deposit-hold`,
    payload,
    withAuth(token)
  );
  return res.data;
}

export async function releaseWorkspaceFinanceDeposit(token, bookingId, payload) {
  const res = await axios.post(
    `${API}/myboothshare/bookings/${bookingId}/deposit-release`,
    payload,
    withAuth(token)
  );
  return res.data;
}

export async function createWorkspaceFinancePayout(token, bookingId, payload) {
  const res = await axios.post(
    `${API}/myboothshare/bookings/${bookingId}/payouts`,
    payload,
    withAuth(token)
  );
  return res.data;
}

export async function retryWorkspaceFinancePayment(token, bookingId) {
  const res = await axios.post(
    `${API}/myboothshare/bookings/${bookingId}/retry-payment`,
    {},
    withAuth(token)
  );
  return res.data;
}
